import {LoginActions} from '../../actions';
import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import epicTracking from 'epic-tracking';
import {generateRoutePath} from 'epic-common/src/route';

const CTASignUp = ({
        isSubscribed,
        isLoggedIn,
        ctaString,
        ...props
    }) => {
        
    const subscribe = React.useCallback(() => {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'BETA_SIGN_UP',
            eventAction: 'betaSignUp'
        });
        if (!isLoggedIn) LoginActions.requestLogin('/beta-sign-up');
        if (isLoggedIn) props.history.push(generateRoutePath('/beta-sign-up'));
    }, [isLoggedIn, LoginActions]);

    return (
        <>
            {isSubscribed ? (
                <h4 className="signed-up"><Message code="epic.spyjinx.signed.up" /></h4>
            ) : (
                <button onClick={subscribe} to={generateRoutePath('/beta-sign-up')} className="btn btn-primary">
                    <span>{ctaString}</span>
                </button> 
            )}
        </>
    );
};
CTASignUp.propTypes = {
    isSubscribed: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object,
    ctaString: PropTypes.string
}

export default CTASignUp;
